import { useMemo } from 'react';
import { productInformationApi } from 'services/api/base';
import { Product, ProductInformation } from 'services/api/entities';
import stripeApi from 'services/api/stripe/stripeApi';

const useStripeProducts = () => {
  const {
    data: productsData,
    isLoading: isProductsLoading,
    isFetching: isProductsFetching,
  } = stripeApi.useGetProductsQuery();

  /** We fetch additional info for the products from these urls. */
  const requestUrls =
    productsData?.map((product) => product.metadata.product_information) || [];

  const {
    data: productInformationData,
    isLoading: isProductInformationLoading,
    isFetching: isProductInformationFetching,
  } = productInformationApi.useGetProductsInformationQuery(requestUrls, {
    skip: !productsData,
  });

  const products = useMemo(() => {
    if (isProductsLoading || isProductInformationLoading) return [];

    if (!productsData || !productInformationData) return [];

    return productsData.map((product, index) => {
      const productInformation = new ProductInformation(
        /*
         * We can assume that the indexes between productInformationData and productsData
         * match, because productInformationData is constructed from productsData.
         */
        productInformationData[index]
      );
      return new Product(product, productInformation);
    });
  }, [
    productsData,
    productInformationData,
    isProductsLoading,
    isProductInformationLoading,
  ]);

  const isFetching = isProductsFetching || isProductInformationFetching;

  return { products, isFetching };
};

export default useStripeProducts;
